import { AuthenticationService } from './../../servicios/authentication.service';
import { Component, OnInit, EventEmitter, ViewChild } from "@angular/core";
import { AguaBloqueosService } from "../../servicios/agua-bloqueos.service";
import { MuestraMensaje } from "../../shared/utilerias/notificaciones/notificaciones.component";
import { MenuItem, SelectItem } from "primeng/api";

import {
  Aguas,
  CargosDetalles,
  CargosDetallesInput,
  AguaBloqueos,
  EstadoCuentaInformacionInput,
  RAguasPersonas,
  ObtenerUsuarioPorCargo,
  ObtenerUsuarioPorCargoInput,
  Personas
} from "../../entidades/entidades";
import { Observable, empty } from "rxjs";

import { RAguasPersonasService } from "../../servicios/r-aguas-personas.service";
import { AguasService } from "../../servicios/aguas.service";
import { PersonasService } from "../../servicios/personas.service";
import { CatTipoBloqueosService } from "../../servicios/cat-tipo-bloqueos.service";
import { CatEstatusService } from "../../servicios/cat-estatus.service";
import { ObtenerUsuarioPorCargoService } from "../../servicios/obtener-usuario-por-cargo.service";

@Component({
  selector: "app-agua-bloqueos",
  templateUrl: "./agua-bloqueos.component.html",
  styleUrls: ["./agua-bloqueos.component.css"],
})
export class AguaBloqueosComponent implements OnInit {
  muestraMensaje = new MuestraMensaje();
  public aguaBloqueos: AguaBloqueos[];
  public aguas$: Observable<Aguas>;
  public aguasLimpio: Aguas;
  public idAguasProceso: number;

  public cargosDetallesInput$ = new EventEmitter<CargosDetallesInput>();
  public cargosDetallesInputLimpio: CargosDetallesInput;
  public cargosDetalles: CargosDetalles;

  public estadoCuentaInformacionInput$ = new EventEmitter<
    EstadoCuentaInformacionInput
  >();
  public estadoCuentaInformacionLimpio: EstadoCuentaInformacionInput;

  public usuario: any;
  public rAguasPersonas: RAguasPersonas;
  public personas$: Observable<Personas>;
  public personasLimpio: Personas;
  public edoCuentaInformacion: EstadoCuentaInformacionInput;

  public aguaBloq: AguaBloqueos;

  itemsMenu: MenuItem[];
  public catUsuarios: ObtenerUsuarioPorCargo[] = [];

  tipoBloqueos: SelectItem[];
  estatus: SelectItem[];
  usuariosSelec: SelectItem[];
  public usuarios: ObtenerUsuarioPorCargoInput;

  columnasTabla: any[];
  public clonedAguaBloqueos: { [s: string]: AguaBloqueos } = {};

  aguasNuevaBusqueda: any;

  constructor(
    private aguaBloqueosService: AguaBloqueosService,

    private aguasService: AguasService,
    private rAguasPersonasService: RAguasPersonasService,
    private personasService: PersonasService,
    private catTipoBloqueosService: CatTipoBloqueosService,
    private catUsuariosService: ObtenerUsuarioPorCargoService,
    private catEstatusService: CatEstatusService,
    private authenticationService: AuthenticationService
  ) { }

  async ngOnInit() {
    //this.getAllAguaBloqueos();
    
    this.getAllCatEstatus();
    this.getAllCatTipoBloqueos();
    

    await this.authenticationService.getUserByToken();
    this.usuario = this.authenticationService.currentUserValue;
    await this.getCatUsuarios();
    // ===============================================================
    //Opciones del menu
    // ===============================================================
    this.itemsMenu = [
      {
        label: "Agrega Bloqueo",
        icon: "pi pi-file-o",
        command: () => this.add(),
      },
      {
        label: "Guardar",
        icon: "pi pi-save",
        command: (event) => {
          this.guardarGridAguaBloqueos();
        },
      },
      {
        label: "Refrescar",
        icon: "pi pi-refresh",
        command: (event) => {
          this.getAllAguaBloqueos(this.aguaBloq);
        },
      },

    ];

    // ===============================================================
    //Opciones de la tabla
    // ===============================================================
    this.columnasTabla = [
      {
        field: "operacion",
        header: "",
        ordenar: false,
        styleHeader: "width: 30px;",
      },
      {
        field: "idEstatus",
        header: "Estatus",
        ordenar: false,
        styleHeader: "width: 130px;",
      },
      {
        field: "idUsuarioBloqueo",
        header: "Usuario Bloqueó",
        ordenar: false,
        styleHeader: "width: 180px;",
      },
      {
        field: "idTipoBloqueo",
        header: "Motivo Bloqueo",
        ordenar: false,
        styleHeader: "width: 140px;",
      },
      {
        field: "fechaFin",
        header: "Fecha Fin",
        ordenar: false,
        styleHeader: "width: 140px;",

      },
      {
        field: "observaciones",
        header: "Observaciones",
        ordenar: false,
        styleHeader: "width: 150px;",
      },
      {
        field: "termina_bloqueo",
        header: "Terminar Bloqueo",
        ordenar: false,
        styleHeader: "width: 60px;",
      },
    /*  {
        field: "acciones",
        header: "",
        ordenar: false,
        styleHeader: "width: 30px;",
      },*/
    ];
  }
  //===============================================================
  //Agrega renglon en el grid
  //===============================================================
  add() {

    // if (this.aguaBloqueos.length>0) {
    //   this.muestraMensaje.error("Solo se permite un bloqueo", "top", "center");
    //   return;
    // }

    let aguaBloqueosNew = new AguaBloqueos();
    aguaBloqueosNew.cambio = true;
    aguaBloqueosNew.id = 0;
    aguaBloqueosNew.fechaFin;
    //aguaBloqueosNew.idAgua = this.aguaBloqueos[0].idAgua;
    this.aguaBloqueos.unshift(aguaBloqueosNew);

    for (let index = 0; index < this.estatus.length; index++) {
      if (this.estatus[index].label = "EN PROCESO") this.aguaBloqueos[0].idEstatus = this.estatus[index].value;
    }

    this.aguaBloqueos[0].idUsuarioBloqueo = this.usuario.id;
  }

  //===============================================================
  //Funciones de la tabla
  //===============================================================
  onEditInit(event) {
    if(event.data.baja) return;
      let aguaBloqueosEdit = event.data;
      this.estatus[7];
      aguaBloqueosEdit.cambio = true;
      aguaBloqueosEdit.baja = false;
      aguaBloqueosEdit.bloqueo = false;
  }

  onEditCancel(event) {
    let aguaBloqueosEdit = event.data;
    let index = this.aguaBloqueos.findIndex(
      (obj) => obj.id === aguaBloqueosEdit.id
    );
    this.aguaBloqueos[index] = this.clonedAguaBloqueos[aguaBloqueosEdit.id];
  }

  onDelete(event, index: number) {
    event.cambio = false;
    event.baja = true;
    event.bloqueo = false;
    event.fechaFin = null;
    //se quitan las observaciones
    event.observaciones = null;
  }

  onUnLock(event, index: number) {
    event.cambio = false;
    event.baja = false;
    event.observaciones = null;
    event.fechaFin = null;
    event.bloqueo = true;
  }

  async onEditComplete(event) {
    try {
      let aguaBloqueosEdit = event.data;

      if (
        aguaBloqueosEdit.id ===
        this.clonedAguaBloqueos[aguaBloqueosEdit.id].id &&
        aguaBloqueosEdit.idTipoBloqueo ===
        this.clonedAguaBloqueos[aguaBloqueosEdit.id].idTipoBloqueo &&
        aguaBloqueosEdit.observaciones ===
        this.clonedAguaBloqueos[aguaBloqueosEdit.id].observaciones &&
        this.clonedAguaBloqueos[aguaBloqueosEdit.id].fechaFin
      ) {
        let index = this.aguaBloqueos.findIndex(
          (obj) => obj.id === aguaBloqueosEdit.id
        );
        this.aguaBloqueos[index] = {
          ...this.clonedAguaBloqueos[aguaBloqueosEdit.id],
        };
        return;
      }

      aguaBloqueosEdit.cambio = true;
      aguaBloqueosEdit.baja = false;
      aguaBloqueosEdit.bloqueo = false;

      delete this.clonedAguaBloqueos[aguaBloqueosEdit.id];
    } catch (e) {
      //this.muestraMensaje.error(e.message, "top", "center");
    } finally {
      console.log("Paso por onEditComplete");
    }
  }
  //===============================================================
  //Interaccion con servicios
  //===============================================================
  async guardarGridAguaBloqueos() {
    try {

      if (!this.aguaBloqueos || this.aguaBloqueos.length === 0) {
          // Mostrar mensaje de que no hay cambios pendientes
          this.muestraMensaje.warning("No hay cambios pendientes por guardar.", "top", "center");
          return;
      }

      for (let aguaBloqueosFor of this.aguaBloqueos) {
        if (aguaBloqueosFor.baja) {
          if(aguaBloqueosFor.observaciones == null)
          {
            this.muestraMensaje.warning("Agregar observaciones antes de eliminar bloqueo.", "top", "center");
            return;
          }
          if (aguaBloqueosFor.id != 0) {
            await this.deleteAguaBloqueos(aguaBloqueosFor);
            this.childAguaBuscaCuentas(this.idAguasProceso ); 
          }
        } else if (aguaBloqueosFor.cambio || aguaBloqueosFor.bloqueo) {
            if (aguaBloqueosFor.id === 0) {
                  
                  aguaBloqueosFor.idAgua = this.aguaBloq.idAgua;
                  aguaBloqueosFor.idUsuarioBloqueo = this.usuario.id;
                  aguaBloqueosFor.idEstatus = 1;
                  // No asignar automáticamente `fechaFin` si ya fue seleccionada
                  //   if (!aguaBloqueosFor.fechaFin) {
                  //     aguaBloqueosFor.fechaFin = new Date(); // Fecha automática solo si no hay una seleccionada
                  // }
        
                  
                  if(aguaBloqueosFor.observaciones == null)
                  {
                    this.muestraMensaje.warning("Agregar observaciones antes de guardar bloqueo.", "top", "center");
                    return;
                  }
                  
                  if(aguaBloqueosFor.idTipoBloqueo == null){
                    this.muestraMensaje.warning("Agregar un tipo de bloqueo.", "top", "center");
                    return;
                  }
                  const datoRetorno = await this.addAguaBloqueos(aguaBloqueosFor);
                  aguaBloqueosFor.id = datoRetorno.id;
                  this.aguaBloqueos[0].idEstatus = 1;
  
            } else {

                  if (aguaBloqueosFor.bloqueo == true || aguaBloqueosFor.cambio) {
                    aguaBloqueosFor.idAgua = this.aguaBloq.idAgua;
                    aguaBloqueosFor.idUsuarioBloqueo = this.usuario.id;
                    var date = new Date(new Date());
                    aguaBloqueosFor.fechaFin = date;
                    aguaBloqueosFor.idEstatus = 5;
                    if(aguaBloqueosFor.observaciones == null)
                    {
                      this.muestraMensaje.warning("Agregar observaciones antes de quitar bloqueo.", "top", "center");
                      return;
                    }
                  }
                  await this.updateAguaBloqueos(aguaBloqueosFor);
                  this.childAguaBuscaCuentas(this.idAguasProceso ); 
                  this.aguaBloqueos[0].idEstatus = 5;
          }
          aguaBloqueosFor.cambio = false;
        }
      }
      
      this.getAllAguaBloqueos(this.aguaBloq);
      
      this.muestraMensaje.notification("Proceso Concluido.", "top", "center");
    } catch (e) {
      this.muestraMensaje.error(e.message, "top", "center");
    } finally {
      console.log("Paso por guardarAguaBloqueos");
      // this.
    }
  }

  async addAguaBloqueos(aguaBloqueos) {
    try {
      const datoretorno = await this.aguaBloqueosService
        .add(aguaBloqueos)
        .toPromise();
        await this.estadoCuentaInformacionInput$.emit(
          null
        );
        await this.estadoCuentaInformacionInput$.emit(
          this.edoCuentaInformacion
        );
      return datoretorno;
    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso por addAguaBloqueos");
    }
  }

  async getAllAguaBloqueos(aguaBloqueos: AguaBloqueos) {
    try {
      const datoRetorno = await this.aguaBloqueosService
        .getSingle(aguaBloqueos.idAgua)
        .toPromise();
      this.aguaBloqueos = datoRetorno;

      for (var i = 0, len = this.aguaBloqueos.length; i < len; ++i) {
        let aguaBloqueosFor = new AguaBloqueos();
        aguaBloqueosFor = this.aguaBloqueos[i];
        if (aguaBloqueosFor.fechaFin != null) {
          aguaBloqueosFor.bloqueo == true;
        }

        this.aguaBloqueos[i] = aguaBloqueosFor;
      }

      for (var i = 0, len = this.aguaBloqueos.length; i < len; ++i)
        this.clonedAguaBloqueos[this.aguaBloqueos[i].id] = {
          ...this.aguaBloqueos[i],
        };

      this.getCatUsuarios();
      this.getAllCatEstatus();
    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso por getAllAguaBloqueos");
    }
  }

  async updateAguaBloqueos(aguaBloqueos: AguaBloqueos) {
    try {
      const datoRetorno = await this.aguaBloqueosService
        .update(aguaBloqueos)
        .toPromise();
        await this.estadoCuentaInformacionInput$.emit(
          null
        );

        await this.estadoCuentaInformacionInput$.emit(
          this.edoCuentaInformacion
        );
        return datoRetorno;

    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso por updateAguaBloqueos");
    }
  }

  async deleteAguaBloqueos(aguaBloqueos: AguaBloqueos) {
    try {
      const datoRetorno = await this.aguaBloqueosService
        .delete(aguaBloqueos.id, aguaBloqueos.observaciones)
        .toPromise();

        await this.estadoCuentaInformacionInput$.emit(
          null
        );
        await this.estadoCuentaInformacionInput$.emit(
          this.edoCuentaInformacion
        );
    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso por deleteAguaBloqueos");
    }
  }

  // =====================================================
  //Carga principal
  // =====================================================
  async childAguaBuscaCuentas(idAgua: number) {
    try {
      this.idAguasProceso = idAgua;

      this.limpiaInput();
      if (!this.idAguasProceso) {
        this.aguas$ = await this.aguasService.getSingle(0);
        this.personas$ = await this.personasService.getSingle(0);

        this.limpiaInput();
        return;
      }

      // carga formulario de agua
      this.aguas$ = await this.aguasService.getSingle(idAgua);

      //Carga formulario de personas
      const rAguasPersonasBusquedas = new RAguasPersonas();
      rAguasPersonasBusquedas.idAgua = idAgua;
      await this.getRAguasPersonas(rAguasPersonasBusquedas);
      this.personas$ = await this.personasService.getSingle(
        this.rAguasPersonas.idPersona
      );

      //Carga formulario estado-cuentas
      this.edoCuentaInformacion = new EstadoCuentaInformacionInput();
      this.edoCuentaInformacion.idAgua = idAgua;
      //this.edoCuentaInformacion.cuentaAgua = aguas.cuentaAgua;
      
      let estadoCuentaInformacionInput = new EstadoCuentaInformacionInput();
      estadoCuentaInformacionInput.idAgua = idAgua;
      //estadoCuentaInformacionInput.cuentaAgua = aguas.cuentaAgua;
      await this.estadoCuentaInformacionInput$.emit(
        estadoCuentaInformacionInput
      );

      this.aguaBloq = new AguaBloqueos();
      this.aguaBloq.idAgua = idAgua;
      this.getAllAguaBloqueos(this.aguaBloq);
    } catch (e) {
      this.muestraMensaje.error(e.message, "top", "center");
    } finally {
      console.log("Paso por childAguas");
    }
  }

  async getRAguasPersonas(rAguasPersonas: RAguasPersonas) {
    try {
      const datoRetorno = await this.rAguasPersonasService
        .getBusquedas(rAguasPersonas)
        .toPromise();
      this.rAguasPersonas = datoRetorno[0];
    } catch (e) {
      if (e.response) {
        throw { message: e.response.data };
      } else {
        throw e;
      }
    } finally {
      console.log("Paso por getRAguasPersonas");
    }
  }

  async getAllCatTipoBloqueos() {
    const datoRetorno = await this.catTipoBloqueosService.getValidados().toPromise();

    this.tipoBloqueos = datoRetorno.map((datos) => {
      return { label: datos.descripcion, value: datos.id };
    });
    // this.tipoBloqueos.unshift({ value: null});
  }

  async getAllCatEstatus() {
    const datoRetorno = await this.catEstatusService.getAll().toPromise();

    // this.estatus.unshift({label: 'SELECCIONA...', value: null});

    this.estatus = datoRetorno.map((datos) => {
      return { label: datos.descripcion, value: datos.id };
    });
    // this.estatus.
    // this.aguasForm.patchValue(this.aguas);
  }

  async getCatUsuarios() {
    try {
      this.usuarios = new ObtenerUsuarioPorCargoInput();
      this.usuarios.idCargo = null;
      this.usuarios.idEstatus = null;

      let datoRetorno = await this.catUsuariosService.getBusquedas(this.usuarios).toPromise();
      let usuarios = datoRetorno; //.filter(x=>x.id == this.usuario.id);

      this.usuariosSelec = usuarios.map((datos) => {return { label: datos.nombre, value: datos.id };});
      //this.usuariosSelec.unshift({ label: this.usuario.nombre, value: this.usuario.id });
      //SE ASIGNA EL USUARIO AL COMBO DE CAJEROS
    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso por getCatUsuarios");
    }
  }

  limpiaInput() {
    this.estadoCuentaInformacionInput$.emit(null);
    this.cargosDetallesInput$.emit(null);
  }
}